import React from "react";
import { StoreAllFilesComponent } from "./Files/AllFilesComponent";
import { StoreFilesScreenComponent } from "./Files/FilesScreenComponent";
import { RoutineEditScreenProps } from "./RoutineAdmin/RoutineEditMain/RoutineEditNavigation";
import { useNavigationHeader } from "../common/navigationHeaderOptions";
import { useIntlTokens } from "../components/mobile/useIntlTokens";
import { useRoutineEditStateSetParamsFunction } from "./RoutineAdmin/State/RoutineEditState";

export function RoutineEditFileSelect({
  navigation,
}: RoutineEditScreenProps<"RoutineEditFileSelect">) {
  const intl_token = useIntlTokens();
  useNavigationHeader({
    type: "BACK",
    title: intl_token.Files,
    onBack() {
      navigation.goBack();
    },
  });

  const setParams = useRoutineEditStateSetParamsFunction();

  return (
    <StoreFilesScreenComponent
      modal
      includeIntegrationFiles={false}
      onPressFile={async ({ fileId, fileType, fileName, url }) => {
        setParams((params) => ({
          ...params,
          addDescriptionFiles: [
            ...params.addDescriptionFiles.filter(({ id }) => id !== fileId),
            {
              id: fileId,
              type: fileType,
              name: fileName,
              url,
            },
          ],
        }));
        navigation.goBack();
      }}
      onShowAllFiles={() => {
        navigation.navigate("RoutineEditAllFiles");
      }}
      setHeaderRight={(p) => navigation.setOptions({ headerRight: p })}
    />
  );
}

export function RoutineEditAllFiles({
  navigation,
}: RoutineEditScreenProps<"RoutineEditAllFiles">) {
  const intl_token = useIntlTokens();
  useNavigationHeader({
    type: "BACK",
    title: intl_token.Files,
    onBack() {
      navigation.goBack();
    },
  });
  const setParams = useRoutineEditStateSetParamsFunction();

  return (
    <StoreAllFilesComponent
      includeIntegrationFiles={false}
      onPressFile={async ({ fileId, fileType, fileName, url }) => {
        setParams((params) => ({
          ...params,
          addDescriptionFiles: [
            ...params.addDescriptionFiles.filter(({ id }) => id !== fileId),
            {
              id: fileId,
              type: fileType,
              name: fileName,
              url,
            },
          ],
        }));
        navigation.popToTop();
      }}
    />
  );
}
